import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import formService from "../../services/forms/form.service";
import { AnketRequestDto } from "../../services/forms/form.dto";
import { useToast } from "../../utils/toast";
import { Checkbox, CheckboxChangeEvent } from "primereact/checkbox";
import VideoComponent from "../../components/VideoComponent";
import ProtokolFirmalarComponent from "../../components/ProtokolFirmalarComponent";
import adminService from "../../services/admin/admin.services";
import { VideoDto } from "../../services/admin/admin.dto";
import { useAuth } from "../../utils/auth";
import { useNavigate } from "react-router-dom";
import LoginRequiredModal from "../../components/LoginRequiredModal";

const getYoutubeThumbnail = (url: string) => {
  const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w-]{11})/);
  const id = match ? match[1] : "";
  return id ? `https://img.youtube.com/vi/${id}/mqdefault.jpg` : "/images/landing-page/afad.jpg";
};

const IsSurekliligi = () => {
  const toast = useToast();
  const auth = useAuth();
  const navigate = useNavigate();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [videos, setVideos] = useState<VideoDto[]>([]);
  const [selectedVideo, setSelectedVideo] = useState<VideoDto | null>(null);

  const formik = useFormik<AnketRequestDto>({
    initialValues: {
      result1: ""
    },
    validate: (values) => {
      const errors: any = {};
      if (!values.result1 || values.result1 === "") {
        errors.result1 = "Bir seçenek seçiniz.";
      }

      return errors;
    },
    onSubmit: async (values) => {
      if (!auth.getUser().access_token) {
        setShowLoginModal(true);
        return;
      }

      formService.afadAnket(values).then((res) => {
        if (res?.result?.error === null) {
          toast.show("Anket kaydedildi.", "success");
        } else {
          toast.show("Anket kaydedilemedi", "error");
        }
      });
    }
  });

  const options = [
    { label: "Evet", value: "evet" },
    { label: "Hayır", value: "hayir" }
  ];

  const handleCheckboxChange = (e: CheckboxChangeEvent) => {
    if (!auth.getUser().access_token) {
      setShowLoginModal(true);
      return;
    }

    const value = e.value;
    let newAnalysisAreas: string = "";

    if (e.checked) {
      newAnalysisAreas = value;
    }

    formik.setFieldValue("result1", newAnalysisAreas);
  };

  useEffect(() => {
    loadVideos();
  }, []);

  const loadVideos = async () => {
    try {
      const response = await adminService.getVideos("IS_SUREKLILIGI");
      if (response?.result?.data) {
        setVideos(response.result.data);
        if (response.result.data.length > 0) {
          setSelectedVideo(response.result.data[0]);
        }
      }
    } catch (error) {
      console.error("Error loading videos:", error);
      toast.show("Video verilerini yüklerken bir hata oluştu.", "error");
    }
  };

  const handleVideoSelect = (video: VideoDto) => {
    setSelectedVideo(video);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      {selectedVideo && (
        <VideoComponent videoUrl={selectedVideo.video_url} header={selectedVideo.title} autoplay={true} />
      )}

      {videos.length > 1 && (
        <div className="card p-3 sm:p-4 mb-3">
          <div className="text-center mb-4">
            <h2 className="text-900 text-2xl sm:text-3xl font-semibold mb-2">İş Sürekliliği Video Arşivi</h2>
          </div>
          <div className="grid">
            {videos.map((video) => (
              <div className="col-12 sm:col-6 lg:col-4" key={video.id}>
                <div
                  className="cursor-pointer border-round-xl overflow-hidden surface-card border-1 transition-duration-200 hover:shadow-2"
                  onClick={() => handleVideoSelect(video)}
                  style={{
                    borderColor: selectedVideo?.id === video.id ? "var(--primary-color)" : "var(--surface-border)",
                    borderWidth: selectedVideo?.id === video.id ? "2px" : "1px",
                  }}
                >
                  <div className="relative" style={{ aspectRatio: "16 / 9" }}>
                    <img
                      src={getYoutubeThumbnail(video.video_url)}
                      alt={video.title}
                      className="w-full h-full"
                      style={{ objectFit: "cover" }}
                    />
                    <div className="absolute top-0 bottom-0 left-0 right-0 flex align-items-center justify-content-center bg-black-alpha-30">
                      <i className="pi pi-play-circle text-white text-4xl opacity-80 hover:opacity-100"></i>
                    </div>
                  </div>
                  <div className="p-3">
                    <h4 className="text-900 m-0 text-base font-semibold line-clamp-2">{video.title}</h4>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="card p-3 sm:p-4 mb-3">
        <div className="text-center mb-4">
          <h2 className="text-900 text-2xl sm:text-3xl font-semibold mb-2">İş Sürekliliği Planı Anketi</h2>
        </div>

        <form onSubmit={formik.handleSubmit}>
          <div className="flex flex-column align-items-start">
            <p className="text-900 font-medium mb-3 line-height-3">
              OSB'nizin afetlerde üretime devam etmesi için bir planınız var mı?
            </p>
            <div className="grid w-full">
              {options.map((option) => (
                <div key={option.value} className="col-12 sm:col-4 flex align-items-center mb-2">
                  <Checkbox
                    inputId={option.value}
                    value={option.value}
                    onChange={handleCheckboxChange}
                    checked={formik.values.result1.includes(option.value)}
                  />
                  <label htmlFor={option.value} className="ml-2 cursor-pointer text-sm sm:text-base">
                    {option.label}
                  </label>
                </div>
              ))}
            </div>

            {formik.errors.result1 && <small className="p-error block mt-1">{formik.errors.result1}</small>}
            <Button label="Gönder" type="submit" icon="pi pi-check" className="mt-3 px-4" />
          </div>
        </form>
      </div>

      <ProtokolFirmalarComponent />
      
      {/* Login Required Modal */}
      <LoginRequiredModal 
        visible={showLoginModal} 
        onHide={() => setShowLoginModal(false)} 
      />
    </>
  );
};

export default IsSurekliligi;
